
<template>
  <div>
    <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition" scrollable style="z-index: 1">
      <!-- <template v-slot:activator="{ on }">
        <v-btn dark small color="indigo" v-on="on">
          <v-icon left>mdi-chat</v-icon> comentar
        </v-btn>
      </template> -->
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Comentários</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeComment()" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="10">
              <v-form ref="commentForm">
                <v-text-field label="Comentário" v-model="comment" :rules="required"></v-text-field>
              </v-form>
            </v-col cols="2">
            <v-col align-self="center">
              <v-btn color="primary" @click="newComment" icon><v-icon large>mdi-send</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-timeline dense clipped>
            <v-slide-x-transition group>
              <v-timeline-item
                v-for="comment in comment_array"
                :key="comment.body + comment.date"
                class="mb-4"
                color="pink"
                small
              >
                <v-row justify="space-between">
                  <v-col
                    cols="7"
                    v-text="comment.body"
                  ></v-col>
                  <v-col
                    class="text-right"
                    cols="5"
                    v-text="$dayjs(comment.date).format('DD/MM/YY HH:mm')"
                  ></v-col>
                </v-row>
              </v-timeline-item>
            </v-slide-x-transition>
          </v-timeline>
        </v-card-text>
        <v-card-actions>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'DialogComments',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  mixins: [
    validations
  ],
  data() {
    return {
      comment: null,
    }
  },
  methods: {
    closeComment() {
      this.comment = null;
      this.$emit('closeComment');
    },
    async newComment() {
      if (this.$refs.commentForm.validate() && this.comment.trim()) {
        let commentary = {
          body: this.comment,
          date: new Date()
        }
        try {
          await this.pushComment(commentary);
        } catch (error) {
          throw error
        }
        this.$refs.commentForm.reset();
      }
    },
    ...mapActions({
      pushComment: 'Execution/pushComment'
    })
  },
  computed: {
    ...mapState({
      comment_array: state => state.Execution.current_execution.comments
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>